module.exports = __webpack_public_path__ + "static/media/20180808_202538.b2592e0e.jpg";